import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import { formatDate, formatViews } from "@/utils/format";

export default function NewsCard({
  article,
  variant = "row",
}: {
  article: NewsItem;
  variant?: "row" | "grid";
}) {
  if (variant === "grid") {
    return (
      <Link
        to={`/news-detail/${article.id}`}
        className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-700"
      >
        <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={`${article.title} - 成人资讯配图`}
            title={`${article.title} 成人资讯`}
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
        </div>
        <div className="p-4">
          <span className="text-[11px] text-accent-500">{article.category}</span>
          <h3 className="mt-1.5 text-sm font-medium leading-relaxed text-foreground-950 transition-colors group-hover:text-accent-500">
            {article.title}
          </h3>
          <p className="mt-1.5 text-xs text-foreground-500">{formatDate(article.publishDate)}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news-detail/${article.id}`}
      className="group flex gap-4 rounded-lg border border-transparent p-2.5 transition-colors hover:border-background-200 hover:bg-background-100"
    >
      <div className="h-[74px] w-[112px] shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} - 成人资讯配图`}
          title={`${article.title} 成人资讯`}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
        />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="line-clamp-2-safe text-[13.5px] font-medium leading-relaxed text-foreground-900 transition-colors group-hover:text-accent-500">
          {article.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
          <span className="text-accent-600">{article.category}</span>
          <span>{formatDate(article.publishDate)}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(article.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}